var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAcesseLaudo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.25,
    stroke: "#12A8EC",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3984 33.8002H31.5984C32.1507 33.8002 32.5984 33.3525 32.5984 32.8002V18.6618L28.0224 14.2002H16.3984C15.8462 14.2002 15.3984 14.6479 15.3984 15.2002V32.8002C15.3984 33.3525 15.8462 33.8002 16.3984 33.8002ZM28.4292 13.2002H16.3984C15.2939 13.2002 14.3984 14.0956 14.3984 15.2002V32.8002C14.3984 33.9048 15.2939 34.8002 16.3984 34.8002H31.5984C32.703 34.8002 33.5984 33.9048 33.5984 32.8002V18.2402L28.4292 13.2002ZM19.1984 18.0002H28.7984V19.2002H19.1984V18.0002ZM28.7984 20.4002H19.1984V21.6002H28.7984V20.4002ZM19.1984 22.8002H28.7984V24.0002H19.1984V22.8002ZM28.7984 25.2002H19.1984V26.4002H28.7984V25.2002ZM19.1984 27.6002H28.7984V28.8002H19.1984V27.6002ZM28.7984 30.0002H19.1984V31.2002H28.7984V30.0002Z",
    fill: "#12A8EC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcesseLaudo);
export default __webpack_public_path__ + "static/media/icon-acesse-laudo.4f65de9f9f8282b3bacfa814bb2b167a.svg";
export { ForwardRef as ReactComponent };